import {createSlice} from "@reduxjs/toolkit";

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalCountRaw: 0,
  entities: null,
  productForEdit: undefined,
  lastError: null,
  links: null,
  product: undefined,
  totalLinkCount: 0,
  totalLinkCountRaw: 0,
  totalLinkCountAction: 0,
  totalLinkCountCheck: 0,
  listLinkLoading: false,
  linkForEdit: undefined,
  buckets: null,
  platforms: null,
  platformsFilters: null,
  productFilters: null,
  listInspectLinkLoading: false,
  linksForInspect: [],
  totalInspectLinkCount: 0,
  totalLinksMatchCount: null,
  totalFilterMatchCount: [],
  conversion: [],
  macroBuckets: null,
  brands: [],
  groups: []
};
export const callTypes = {
  list: "list",
  links: "links",
  action: "action",
  match: "match",
  filters: "filters"
};

export const productsSlice = createSlice({
  name: "products",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.listLinkLoading = false;
        state.listInspectLinkLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
        state.listLinkLoading = true;
        state.listInspectLinkLoading = true;
      } else if (action.payload.callType === callTypes.links) {
        state.links = null;
        state.productFilters = null;
        state.listLinkLoading = true;
        state.listInspectLinkLoading = true;
        state.totalLinkCount = false;
        state.macroBuckets = null;
      } else if (action.payload.callType === callTypes.match) {
        state.totalLinksMatchCount = null;
      } else if (action.payload.callType === callTypes.filters) {
        // void
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    productFetched: (state, action) => {
      state.actionsLoading = false;
      state.productForEdit = action.payload.productForEdit;
      state.error = null;
    },
    // findProducts
    productsFetched: (state, action) => {
      const { totalCount, totalCountRaw, entities, brands, groups } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.totalCountRaw = totalCountRaw;
      state.brands = brands;
      state.groups = groups;
      state.links = null;
      state.buckets = null;
      state.totalLinkCount = 0;
      state.product = undefined;
      state.totalFilterMatchCount = [];
    },
    // createProduct
    productCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.product);
    },
    // updateProduct
    productUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.product.id) {
          return action.payload.product;
        }
        return entity;
      });
    },

    // updateProduct
    productImagesUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.productForEdit.image = action.payload.images;
    },

    // deleteProduct
    productDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteProducts
    productsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // productsUpdateState
    productsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // findProductLinks
    productAllLinksFetched: (state, action) => {
      const { totalLinkCount, links} = action.payload;
      state.listInspectLinkLoading = false;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.linksForInspect = links;
      state.totalInspectLinkCount = totalLinkCount;
      state.totalLinkCount = totalLinkCount;
    },
    productNextLinksFetched: (state, action) => {
      const { totalLinkCount, links} = action.payload;
      state.listInspectLinkLoading = false;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.linksForInspect = links;
      state.totalInspectLinkCount = totalLinkCount;
      state.totalLinkCount = totalLinkCount;
    },
    // findProductLinks
    productLinksFetched: (state, action) => {
      const { totalLinkCount, totalLinkCountRaw, links, product, buckets, platforms, conversion} = action.payload;      
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.productFilters = null;
      state.links = links;
      state.buckets = buckets;
      state.platforms = platforms;
      state.product = product;
      state.conversion = conversion;
      state.totalLinkCount = totalLinkCount;
      state.totalLinkCountRaw = totalLinkCountRaw;
    },
    // findMacroProductLinks
    productMacroLinksFetched: (state, action) => {
      const { totalLinkCount, links, macroBuckets, type} = action.payload;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.productFilters = null;
      state.links = links;
      state.macroBuckets = macroBuckets;
      if (type === "action") {
        state.totalLinkCountAction = totalLinkCount;
      } else {
        state.totalLinkCountCheck = totalLinkCount;
      }
      state.totalLinkCount = totalLinkCount;
    },
    // findProductLinksMatched
    productLinksMatchedFetched: (state, action) => {
      const { totalLinksMatchCount } = action.payload;
      state.error = null;
      state.totalLinksMatchCount = totalLinksMatchCount;
    },
    // findProductLinkMatched (filter numbers)
    productLinkMatchFetched: (state, action) => {
      const { index, totalLinksMatchCount } = action.payload;
      state.error = null;
      if (index) {
        state.totalFilterMatchCount[index-1] = totalLinksMatchCount;
      }
    },
    // getLinkById
    productLinkFetched: (state, action) => {
      state.actionsLoading = false;
      state.linkForEdit = action.payload.linkForEdit;
      state.conversion = action.payload.conversion || state.conversion;
      state.error = null;
    },
    // updateLink
    productLinkUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.links = state.links.map(link => {
        if (link.id === action.payload.link.id) {
          return action.payload.link;
        }
        return link;
      });
    },
    // findProductFilters
    productFiltersFetched: (state, action) => {
      const { productFilters, platforms } = action.payload;
      state.listLinkLoading = false;
      state.listLoading = false;
      state.error = null;
      state.productFilters = productFilters;
      state.platformsFilters = platforms;

    },
    // updateFilter
    filterLinesUpdated: (state, action) => {
      const { id, lines } = action.payload;

      const updatedFilter = state.product.filter.findIndex((filter) => {
        return filter.id == lines.id;
      });

      if (updatedFilter > -1) {
        state.product.filter[updatedFilter].filter_lines = lines.lines;
        state.product.filterUpdated = [];
        state.product.filterUpdated[updatedFilter] = lines;
      }
    },
  }
});

